export default __webpack_public_path__ + "static/media/icon-agent-hands-up-acknowledged.52befbd8.svg";